import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import SelectStyled from "commonComponents/FormElement/Select";
import { AccordionStyled } from "assets/css/globle";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { ADMIN_SITE_SETTINGS, SITEID_GLOBAL_STATE } from "../../../globalStore/globalStore";
import {
  Container,
  Heading,
  WorkSection,
  BoxWrapper,
  ActionWrapper,
} from "pages/Admin/SiteSettings/SettingStyled";
import { useSelector, useDispatch } from "react-redux";
import { Loader } from "commonComponents/Loader/Loader";
import { useHookstate } from "@hookstate/core";
import LocalizationSettings from "pages/Admin/SiteSettings/LocalizationSettings";
import CourseSettings from "pages/Admin/SiteSettings/CourseSettings";
import SiteDataConfiguration from "pages/Admin/SiteSettings/SiteDataConfiguration";
import TeeMarkerSettings from "pages/Admin/SiteSettings/TeeMarkerSettings";
import HoleDataSettings from "pages/Admin/SiteSettings/HoleDataSettings";
import { useTranslation } from "react-i18next";
import { Button, Tooltip } from "@mui/material";

export const SiteSettings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const { selectedCustomerServiceProfile } = useHookstate(ADMIN_SITE_SETTINGS);
  const { getCustomerServiceProfileData, siteSettingsData } =
    useSelector((state) => state.commonReducers) || [];

  const [toggleRefresh, setToggleRefresh] = useState(false);

  const saveCustomerServiceProfileSetting = () => {
    setToggleRefresh(true);
    dispatch(
      COMMON_SERVICES.saveCustomerServiceProfileSetting(
        selectedCustomerServiceProfile.get(),
        siteId.get()
      )
    );
  };
  useEffect(() => {
    setToggleRefresh(false);
    selectedCustomerServiceProfile.set(siteSettingsData.VodafoneCspId);
  }, [siteSettingsData]);

  return (
    <Container>
      <AccordionStyled>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Heading>
              <h3>{t("Configuration_Settings")}</h3>
            </Heading>
          </AccordionSummary>
          {toggleRefresh ? (
            <Loader />
          ) : (
            <AccordionDetails>
              <WorkSection>
                <BoxWrapper>
                  <div className="select-wrapper">
                    <p className="label">{t("Customer_Service_Profile")}</p>
                    <SelectStyled
                      id="siteSettings"
                      value={selectedCustomerServiceProfile.get()}
                      data={
                        getCustomerServiceProfileData.length > 0 &&
                        getCustomerServiceProfileData.map((it) => {
                          return {
                            value: it.Id,
                            lable: it.DisplayName,
                          };
                        })
                      }
                    ></SelectStyled>
                    <ActionWrapper>
                      <Tooltip title={t("Save_configuration_settings")} arrow>
                        <span>
                          <Button
                            className={
                              siteSettingsData?.VodafoneCspId ==
                                selectedCustomerServiceProfile.get()
                                ? ""
                                : "active"
                            }
                            onClick={saveCustomerServiceProfileSetting}
                            disabled={
                              siteSettingsData?.VodafoneCspId ==
                              selectedCustomerServiceProfile.get()
                            }
                          >
                            {t("Save")}
                          </Button>
                        </span>
                      </Tooltip>
                    </ActionWrapper>
                  </div>
                </BoxWrapper>

                <BoxWrapper>
                  <p className="label">{t("Product_Level")}</p>
                  <Heading>
                    <h2>{t("Visage_tiered")}</h2>
                  </Heading>
                </BoxWrapper>
              </WorkSection>
            </AccordionDetails>
          )}
        </Accordion>
      </AccordionStyled>
      <LocalizationSettings />
      <CourseSettings />
      <SiteDataConfiguration />
      <TeeMarkerSettings />
      <HoleDataSettings />
    </Container>
  );
};
